
    <div class="ui-g-12">
      <div class="ui-g-6">
        <div class="ui-g-12">
          <div [kv-form-element]="{ label: 'loyalty.domiciliation_card_from', md: '10'}">
            <input style="{width:100%;}" pInputText type="text" [value]="cardFrom ? cardFrom.card_no : ''" [readOnly]="true" >
          </div>
          <div class="ui-g-1" style="padding-top: 45px;">
            <p-button pTooltip="{{ 'common.select' | translate }}" icon="fa fas fa-arrow-circle-right"  styleClass="ui-button-info" (onClick)="onOpenSearchCardFrom()"></p-button>
          </div>
        </div>
        <div class="ui-g-12" style="text-align: center;" *ngIf="showSearchCardFrom">
          <i style="font-size: 30px;" class="fa fa-fw fa-caret-down"></i>
        </div>
      </div>

      <div class="ui-g-6">
        <div class="ui-g-12">
          <div [kv-form-element]="{ label: 'loyalty.domiciliation_card_to', md: '10'}">
            <input style="{width:100%;}" pInputText type="text" [value]="cardTo ? cardTo.card_no : ''" [readOnly]="true" [disabled]="cardFrom == null">
          </div>
          <div class="ui-g-1" style="padding-top: 45px;">
            <p-button pTooltip="{{ 'common.select' | translate }}" icon="fa fas fa-arrow-circle-right"  styleClass="ui-button-info" (onClick)="onOpenSearchCardTo()" [disabled]="cardFrom == null"></p-button>
          </div>
        </div>
        <div class="ui-g-12" style="text-align: center;" *ngIf="showSearchCardTo">
          <i style="font-size: 30px;" class="fa fa-fw fa-caret-down"></i>
        </div>
      </div>
      
      <div *ngIf="cardDomiciliationRange != null">
        <div class="ui-g-12">
          <div [kv-form-element]="{ label: 'loyalty.domiciliation_card_massive_range_total', md: '4'}">
          </div>
          <div class="ui-g-8" style="text-align: center;">
            <label style="{width:100%;}" style="text-align: center;" >{{cardDomiciliationRange.length}}</label>
          </div>
        </div>
        <div class="ui-g-12">
          <div [kv-form-element]="{label: 'card.domiciliation_select_store', md: '12'}">
            <p-dropdown [(ngModel)]="destinationStore" [options]="filteredStoresListItem"></p-dropdown>
          </div>
        </div>
        <div class="ui-g-12" *ngIf="cardDomiciliationRange != null">
          <div class="ui-g-4"></div>
          <div class="ui-g-4">
            <button pButton type="button" class="buttonExpand k-generic-btn" icon="fa fa-search" iconPos="left" [label]="'loyalty.domiciliation_massive_range_perform' | translate" (click)="performDomiciliation()" ></button>
          </div>
          <div class="ui-g-4"></div>
        </div>
      </div>
      
    </div>
    
    <kv-customer-card-search
      *ngIf="showSearchCardFrom && !showSearchCardTo"
      (onCardSelect)="onCardFromSelect($event)"
      (onBack)="showSearchCardFrom = false"
    ></kv-customer-card-search>
    <kv-customer-card-search
      *ngIf="!showSearchCardFrom && showSearchCardTo && filterLoyaltyChannel.type != 0"
      (onCardSelect)="onCardToSelect($event)"
      (onBack)="showSearchCardTo = false"
      [filter]="filterLoyaltyChannel"
    ></kv-customer-card-search>
    
    
  


// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-domiciliation/loyalty-domiciliation-massive-range.component.ts.LoyaltyDomiciliationMassiveRangeComponent.html